import * as PropertyBucket from "../../Properties/Properties";
import * as httpService from "../../Components/HttpService/HttpService";
import {IProgramDescriptors, IUser} from "../Reducers/userData";


export function dataRequest() {
  return {
    type: GET_USER_DATA_REQUEST,
  };
}

export function userDataSuccess(data: IUser) {
  return {
    type: GET_USER_DATA_SUCCESS,
    payload: data,
  };
}

export function dataFailed(error: string) {

  localStorage.clear();

  return {
    type: GET_USER_DATA_FAILED,
    payload: error,
  };
}

export function getUserData() {
  let url = PropertyBucket.getUserInfo();

  return (dispatch: any) => {
    dispatch(dataRequest());
    let req = httpService.getServicePromise(url, "GET");
    req
    .then((userData) => {
      dispatch(userDataSuccess(userData));
      // legacy compatibility needs
      if ((localStorage.getItem('user') !== `${userData.userFirstName} ${userData.userSurname}`) || (localStorage.getItem('userLogin') !== userData.login)) {
        localStorage.removeItem('programs');
        localStorage.removeItem('selectedProgram');
      }
      localStorage.setItem('user', userData.userFirstName + ' ' + userData.userSurname);
      localStorage.setItem('userRole', userData.roleDetails?.role);
      localStorage.setItem('userOrg', userData.organization?.name || "");
      localStorage.setItem('userLogin', userData.login);
      localStorage.setItem('programDescriptors', userData.roleDetails?.programDescriptors?.map((item: IProgramDescriptors) => item.original)?.toString() || []);
      })
      .catch((error) => {
        dispatch(dataFailed(error));
      });
  };
}


export const GET_USER_DATA_REQUEST = "GET_USER_DATA_REQUEST";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILED = "GET_USER_DATA_FAILED";
